module.exports = __webpack_public_path__ + "img/UHF INLAY.f46fba26.jpg";